import { ReportsService } from 'src/app/services/reports.service';
import { ProspectModel } from './../../../model/ProspectModel';
import { Prospect } from 'src/app/model/Prospect';
import { environment } from './../../../../environments/environment';
import { DataServiceService } from './../../../services/data-service.service';
import { SharedService } from './../../../services/shared.service';
import { ProductService } from 'src/app/services/product.service';
import { ActiveSessionsReqObj } from './../../../model/ApiRequests/ApiReqObj';
import { UploadFile } from 'ng-zorro-antd';

import { AccountService } from './../../../services/account.service';
import { ActiveSessions, AccountStateInfo } from './../../../model/activeSessions';
import { AuthenticationService } from './../../../services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/model/UserModel';
import { UserDetail, UserDetailResult } from "src/app/model/UserDetail";
import { ToastrService } from 'ngx-toastr';
import { stringify } from '@angular/compiler/src/util';
import { ProductApiResponse } from 'src/app/model/Product';
import { ServicePlan } from 'src/app/model/RenewPlan';
import { Router } from '@angular/router';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';
import { alreadyHasAThemeSuffix } from '@ant-design/icons-angular';
import { DataUnitofMeasureInfo } from 'src/app/model/selfcareproducts';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentModel } from 'src/app/model/PaymentModel';
import { Utilities } from 'src/app/services/common/Utility';
import { CustomerProspectService } from 'src/app/services/customer-prospect.service';
import { MapCoverage, CoverageResult } from "src/app/model/Coverage";
@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.css']
})
export class DashboardHomeComponent implements OnInit {
  referFriendForm: FormGroup;
  initloading: boolean = true;
  userdetail: UserDetailResult;
  firstname: string;
  planname: string;
  planstatus: string;
  activeProducts2: any;
  activeProducts: LteActiveSession[];
  customer: any;
  MDN1: string;
  totalGb: string;
  currentUsage: string;
  loanStatus: boolean;
  daysLeft: string;
  progress: any;
  currentUser: UserModel;
  config: object;
  selectedOptions: any;
  customerBalance: number;
  accType: any;
  referralcode: string;
  referralError: string;
  tranSuccess: boolean;
  tranFailed: boolean;
  dynamicUrl: string;
  referVisible = false;
  expiryDate : string;
  CurrentUsagein3decimal: string;
  isTopUpAble: boolean=true;
  userstatus:string='';
  statusColor:string ="Blue";
  statusText:string ="";

  constructor(private fb: FormBuilder, private toastr: ToastrService, private router: Router, private sharedService: SharedService, private productService: ProductService, private authenticationService: AuthenticationService, private accountService: AccountService, private dataService: DataServiceService, private customerService: CustomerProspectService) {

    this.currentUser = this.authenticationService.getCurrentUser();


    this.firstname = this.currentUser.FirstName;



    if(this.currentUser.i_Account == "0")
    {
   let KycStatus :string = this.currentUser.KycStatus;

   if(KycStatus)
   {
    if(KycStatus.toLowerCase() === "Rejected".toLowerCase() || KycStatus.toLowerCase() === "No Kyc".toLowerCase())
    { 
      this.router.navigate(['/kyc']); 

    }


   }
  
     
 
    }


    this.dataService.currentAccountType.subscribe(acc => {
      this.accType = acc;//? acc: true;
      this.fetchAccounts();

    });
 //

  }

  ngOnInit() {
    this.dynamicUrl = `${location.protocol}//${location.host}`;
    this.referFriendForm = this.fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required]],
      followup: [null, [Validators.required]],
    });

  }

  async selectionChanged(e) {
    
    var acc = e.value.i_account;
    await this.getAccountDetail(acc);
  }




  async getSelectedAccount(i_account) {
    
    await this.getAccountDetail(i_account);
  }

  async getAccountDetail(i_account) {

    try {

      let reqObj = {
        i_account: i_account
      }

      let millisecondsInDays = 86400000;
      let today =new Date().setHours(0,0,0,0);

      var model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
      model.i_account = i_account;
      model.DownloadType = "ACC:GetDetail";

      //let userDetailResult = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
      let userDetailResult = await this.accountService.getAccountDetailFromLteHttp(model.i_account).toPromise();
      if (!userDetailResult) {
      
        
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }

      //this.userdetail = userDetailResult.Result[0];
      this.userdetail = userDetailResult.Result;

      if(this.currentUser.NINStatus === ""||this.currentUser.NINStatus === null)
      {
        this.statusColor='red';
        this.statusText='NotUploaded';
      }

      else{
      if(this.currentUser.NINStatus.toLowerCase() === "VerificationUnMatched".toLowerCase())
      {
        this.statusColor='red';
        this.statusText='UnMatched';
      }
      if(this.currentUser.NINStatus.toLowerCase() === "AwaitVerification".toLowerCase() )
      {
       this.statusColor='purple';
       this.statusText='Verifying';
      }
      if(this.currentUser.NINStatus.toLowerCase() === "Verified".toLowerCase() || this.currentUser.NINStatus.toLowerCase()==='VerifiedWithContact' )
      {
       this.statusColor='green';
       this.statusText='Verified';
      }
      if(this.currentUser.NINStatus.toLowerCase() === 'InValidNin'.toLowerCase() )
      {
       this.statusColor='red';
       this.statusText = 'InValid';
      }
    }
      
      const userdetail = this.userdetail;
      this.planname = userdetail.Product.Name;
      this.setStatus(userdetail.AccountState);
      this.MDN1 = userdetail.subscriber.FirstName ? `${userdetail.subscriber.FirstName} - ${userdetail.ID}` : userdetail.ID;
      let voiceproduct = userdetail.Product.Name.toLowerCase().includes("voice");

//for enterprise
      this.userstatus=this.userdetail.CustomerClass;

      if (voiceproduct) {
        
        this.currentUsage = "₦" + userdetail.Balance.toLocaleString();
      } else {
        this.currentUsage = parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(2) + " " + DataUnitofMeasureInfo[userdetail.Product.Display.DataCapacity.UnitofMeasure];
       this.isTopUpAble= (!(this.userdetail.Product.Display.DataCapacity.UnitofMeasure==9));
      
       if(this.userdetail.Product.Display.DataCapacity.UnitofMeasure==9){
        this.loanStatus=this.userdetail.Balance<1600;
        if(this.userdetail.Product.i_product==148){
          this.loanStatus= this.userdetail.Balance<760;}

      }
      else{
        this.CurrentUsagein3decimal= parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(3) + " " + DataUnitofMeasureInfo[userdetail.Product.Display.DataCapacity.UnitofMeasure];
      this.loanStatus= Number.parseFloat( this.CurrentUsagein3decimal)< 0.5;
      console.log(this.CurrentUsagein3decimal);
      console.log(this.loanStatus);
      
    }
      }
      let expiryDate = Date.parse(userdetail.ExpirationDate.toString());
      let daysLeft = Math.round((expiryDate - today) / millisecondsInDays);
    
      this.daysLeft = (daysLeft < 0 ? "0" : daysLeft) + ' days left' ;
      this.expiryDate = new Date(userdetail.ExpirationDate).toDateString();
      
    //console.log(this.userdetail.Product.Display.DataCapacity.UnitofMeasure);

      let res = await this.accountService.getCustomerBalance(userdetail.i_customer).toPromise();
      if (res.Result) {
        
        //this.sharedService.CustomerBalance = Math.round(res.Result);
        this.customerBalance = Math.round(res.Result);
      }

      this.customerBalance  = this.customerBalance ? this.customerBalance : 0;

      this.initloading = false;

    }
    catch (err) {
      
      this.toastr.error(environment.GenericErrorMsg, "Error");
    }

  }

  calculateProgess(current, total) {

    if (current <= 0 || total <= 0) {
      return 0;
    }
    console.log(current);
    console.log(total);
    let progress = (current * 1000) / (total * 1000);

    return progress * 100;
  }

  changePlan() {

    let account = this.userdetail;
    if (!account) {
      return;
    }

    if(this.userdetail.block==environment.pausedAccId){
      this.toastr.error("You cannot changeplan of a paused account. Please contact Customer Care");
      return;
    }

    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("Change plan is only available on data plans", "Error")
      return;
    }
    if (!this.userdetail.Product.IsChangeable) {
      
      this.toastr.error("Change Plan is not Available for this Account", "Error")
      return;
    }



    this.router.navigateByUrl(`/renewplan?acc=${this.userdetail.i_account}&changeplan=true`);
  }

  Renewal() {


    let account = this.userdetail;
    if (!account) {
      return;
    }

    if(this.userdetail.block==environment.pausedAccId){
      this.toastr.error("You cannot renew a paused account. Please contact Customer Care");
      return;
    }
    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.router.navigateByUrl('/renewplanvoice?acc=' + this.userdetail.i_account);
      return;
    }

    this.router.navigateByUrl('/renewplan?acc=' + this.userdetail.i_account);

  }

  fundwallet() {
    this.router.navigateByUrl('/funddatareserve');
  }

  topupdata() {

    let account = this.userdetail;

    if (!account) {
      return;
    }

    if (account.AccountState == environment.expiredAccId) {
      this.toastr.error("Cannot topup an expired account");
      return;
    }
    if(this.userdetail.block==environment.pausedAccId){
      this.toastr.error("You cannot topup a paused account. Please contact Customer Care");
      return;
    }
    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("top up is only available on data plans", "Error");
      return;
    }

    this.router.navigateByUrl('/topup?acc=' + this.userdetail.i_account);
  }

  requestloan() {
    let account = this.userdetail;

    if (!account) {
      return;
    }
    if(this.userdetail.block==environment.pausedAccId){
      this.toastr.error("You cannot request loan with a paused account. Please contact Customer Care");
      return;
    }
    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("loan request is only available on data plans", "Error");
      return;
    }

    this.router.navigateByUrl('/requestloan?acc=' + this.userdetail.i_account);

  }

  async fetchAccounts() {

    var my_object = this.currentUser;
    let activeSessionRequest: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    activeSessionRequest.DownloadType = "ACC:GetDetail";

    try {
      if (my_object) {
        
        var iAccount = parseInt(my_object.i_Account);
        activeSessionRequest.i_customer = parseInt(my_object.i_Customer);

        if (iAccount == 0)   //  customer with multiple accounts
        {
          
          //an individual
         
          await this.setActiveSession(activeSessionRequest);

        }
        else  // single account
        {
          
          activeSessionRequest.i_account = parseInt(my_object.i_Account);
          await this.setActiveSession(activeSessionRequest);
        }

      }
    } catch (e) {
      
      console.log(e);
      this.toastr.error(environment.GenericErrorMsg);
    }
  }

  async setActiveSession(model: ActiveSessionsReqObj) {

    if (model) {
      let res = await this.accountService.getActiveSessionsFromLteHttp(model,12).toPromise();

      
      if (!res.Result) {
        this.toastr.error("An error occured, Couldn't get active sessions", "Error");
        return;
      }
      let activeSessions: LteActiveSession[] = [] as LteActiveSession[];

      if (this.accType == "VOICE") {
        
        activeSessions = <LteActiveSession[]>res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice")).slice(0, 10);
      }
       else
       {
         
        activeSessions = <LteActiveSession[]>res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice")).slice(0, 10);
      }

      // this.activeProducts = activeSessions.map(a => {
      //   return <any>{
      //     subscriber : a.subscriber,
      //     AccountName: a.AccountName,
      //     ID: a.ID,
      //     i_account: a.i_account,
      //     Display: a.AccountName ? a.AccountName : a.ID
      //   }
      // });
      this.activeProducts = activeSessions;
      var firstAcc = this.activeProducts[0];
        
      this.selectedOptions = {
        AccountName: firstAcc.AccountName,
        ID: firstAcc.ID,
        i_account: firstAcc.i_account,
        Display: firstAcc.AccountName ? firstAcc.AccountName : firstAcc.ID
      }

      await this.getAccountDetail(firstAcc.i_account);

    }
  }

  setStatus(accountState) {
    switch (accountState) {
      case 0: {
        this.planstatus = "Blocked";
        break;
      }
      case 1: {
        this.planstatus = "Active";
        break;
      }
      case 2: {
        this.planstatus = "ZeroBalance";
        break;
      }
      case 3: {
        this.planstatus = "Expired";
        break;
      }
      default: {

        break;
      }

    }

  }


  openFriendReferal(): void {
    this.referVisible = true;
  }

  close(): void {
    this.referVisible = false;
  }

  async submitReferForm(form: FormGroup) {

    try {
      if (!form.status) {
        this.toastr.error(environment.GenericErrorMsg);
        return;
      }

      let model: Prospect = {} as Prospect;
      model.FirstName = form.value.firstName;
      model.LastName = form.value.lastName;
      model.EmailAddress = form.value.email;
      model.MobilePhone = form.value.phone;
      model.FollowUp = form.value.followup == "Yes" ? true : false;
      model.AddressStreet = "Adeola Odeku";
      model.AddressArea = "Adeola Odeku";
      model.AddressCity = "Victoria Island";
      model.AddressState = "Lagos";
      model.AddressCountry = "Nigeria";
      model.Device1 = "tt";
      model.SIMCode = "tt";
      model.i_customer = parseInt(this.currentUser.i_Customer);
      model.ReferralCode = "Code";
      model.CreationDate = new Date();
      model.CreatedBy = this.currentUser.UserName;
      model.OperatorCode = environment.OperatorID;

      let paymentModel: PaymentModel = Utilities.MapProspect(model);

      let res = await this.customerService.savenewProspect(paymentModel).toPromise();

      if (!res.Status) {
        this.tranFailed = true;
        this.referralError = res.Message;
        return;
      }

      this.tranSuccess = true;
      this.referralcode = res.Result.Customer.ReferralCode;
      this.referFriendForm.reset();
    } catch (e) {
      this.toastr.error(environment.GenericErrorMsg);
    }
  }
}
